module.exports = __webpack_public_path__ + "img/icon-white-56.637a07f4.svg";